'use strict';

import React, { useEffect, useRef, useState } from 'react'

import _ from 'lodash'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import HolidaysMessage from '@/HolidaysMessage'

import ModelPicker from '@/Form/V2/ModelPicker'

import ProductRefDetails from '@/ProductRefDetails'

import ProductRefPdfForm from '@/ProductRefPdfForm'

const FORM_NAME = 'DiscountCodeImport';

export default PageWrapper(function DiscountCodesExamplePage (props)
{
	const [form_data, setFormData] = useState({ });
	const [status, setStatus] = useState({ status_messages: { } });

	let validate_btn_modifiers = ['extra'];

	if (status.info || !form_data.import?.length > 0  || !form_data.ref)
	{
		validate_btn_modifiers.push('disabled');
	}

	return (
		<Layout page_title="PDF exemple code promo" history={ props.history }>

			<div className="page-content">
				<HolidaysMessage />

				<div className="c-paper">

					<div className="o-grid-2">

						<div className="o-grid__item">

							<ModelPicker name="ref"
								label="Ref. prix produit"
								model="ProductRef"
								error={ status.fields?.['ref']?.error }
								bemit={ ['100%', 'import-promo-refs'] }
								form={ FORM_NAME }
								url="/autocomplete/products-refs"
								onChange={ handleRefChange }
								value={ form_data.ref }
							/>

						</div>

					</div>

					{
						form_data.ref ?
						(
							<ProductRefDetails product_ref={ form_data.ref } />
						)
						: undefined
					}

					{
						form_data.ref ?
						(
							<ProductRefPdfForm product_ref={ form_data.ref } />
						)
						: undefined
					}

				</div>

			</div>

		</Layout>
	);

	function handleRefChange ({ e, name, value })
	{
		if (form_data[name] === value) return;

		const status_messages = { ...(status.status_messages || { }) };

		status_messages[name] = status_messages[name] || { };

		status_messages[name].error   = undefined;
		status_messages[name].info    = undefined;
		status_messages[name].warning = undefined;

		setStatus(
		{
			...status,

			ref: undefined,

			status_messages: status_messages,

			info: undefined,
			error: undefined,
			warning: undefined,

			errors: undefined
		});

		setFormData(function (form_data)
		{
			return { ...form_data, [name]: value };
		});
	}
});